import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.kreonet.notice');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'wiz-portal-kreonet-notice',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.kreonet.notice/view.scss */
/* src/app/portal.kreonet.notice/view.scss: no such file or directory */`],
})
export class PortalKreonetNoticeComponent implements OnInit {
    constructor(@Inject( Service) public service: Service,@Inject( Title)  private title: Title) { }

    public notices: any = [];

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(true, "/authenticate");
        this.title.setTitle("대시보드 - MY KREONET");
        await this.load();
    }

    public async load() {
        const { code, data } = await wiz.call("load");
        if (code != 200) return await this.service.alert.error("Error!");
        this.notices = data;
        await this.service.render();
    }
}

export default PortalKreonetNoticeComponent;